// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1kXpy","infoBtn":"quickbooks_infoBtn__83LiL","formBox":"quickbooks_formBox__1rflj","formFooter":"quickbooks_formFooter__3KXNh"};